<template>
    <div class="wxLoginPageLoadBox">
        <div class="wxLoginPageLoad">
            <el-image
                    :src="require('../../static/image/common/loading.gif')"
                    fit="scale-down"></el-image>
            <div class="text">{{msg}}
                <div class="borderBottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loading",
        props:['msg']
    }
</script>

<style>
    .wxLoginPageLoadBox{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        background-color: rgba(255,255,255,.8);
    }
    .wxLoginPageLoad{
        text-align: center;
        /*background-color: #fff;*/
        border-radius: 20px;
        width: 400px;
        height: 400px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        -moz-user-select:none; /*火狐*/
        -webkit-user-select:none; /*webkit浏览器*/
        -ms-user-select:none; /*IE10*/
        -khtml-user-select:none; /*早期浏览器*/
        user-select:none;
    }

    .wxLoginPageLoad .text{
        animation: text 0.6s ease-in-out 1.3s infinite alternate;
        font-size: 15px;
        margin-top: -100px;
        -moz-user-select:none; /*火狐*/
        -webkit-user-select:none; /*webkit浏览器*/
        -ms-user-select:none; /*IE10*/
        -khtml-user-select:none; /*早期浏览器*/
        user-select:none;
    }
    .wxLoginPageLoad .borderBottom{
        background-color: #8ef2c8;
        border-radius: 50%;
        height: 8px;
        width: 46px;
        margin: 8px auto;
    }

    @keyframes text{
        from{transform:translate(0,0)}
        to{transform:translate(0,9px)}
    }
</style>